<ul>
  {#each links as link}
  <li>
    <a href="{link.href}" title="{link.name}" class="{colorClassNames.primary}" target="_blank" rel="noopener noreferrer">
      <span role="img" aria-label="{link.name}" class="mh-social-icon-{link.icon}"></span>
    </a>
  </li>
  {/each}
</ul>

<style lang="less">
  @import (reference) '../../../less/variables';

  ul {
    margin: 20px 0 0 0;
    padding: 0;
  }

  li {
    display: inline-block;

    &:not(:last-child) {
      margin-right: @masthead-gutter-width;
    }
  }

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
    width: @masthead-footer-social-icon-size-tablet;
    height: @masthead-footer-social-icon-size-tablet;
    background-color: @masthead-gray-10;

    &:hover {
      color: currentColor;
    }

    @media (min-width: @breakpoint-tablet) {
      width: @masthead-footer-social-icon-size-desktop;
      height: @masthead-footer-social-icon-size-desktop;
    }

    span {
      display: block;
      width: 24px;
      height: 24px;
    }

    .icon-background(@name) {
      .mh-social-icon-@{name} {
        background: no-repeat
            svg-load('./social-icons/@{name}.svg', fill= @masthead-gray-10),
          currentColor;
      }
    }

    .icon-background(facebook);
    .icon-background(instagram);
    .icon-background(twitter);
  }
</style>

<script>
  export let links = [];
  export let colorClassNames;
</script>
